import {
  Card,
  Dialog,
  DialogContent,
  DialogTitle,
  Fab,
  IconButton,
  Tooltip,
  Typography,
  TextField,
  Autocomplete,
  Grid,
  Checkbox,
  FormControlLabel
} from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DataTable from "examples/Tables/DataTable";
import { useEffect, useState } from "react";
import ApiCalls from "services/flick_erp_api_call";
import InfoIcon from "@mui/icons-material/Info";
import MDBox from "components/MDBox";
import SalesTable from "examples/Tables/SalesTable";
import MDTypography from "components/MDTypography";
import moment from "moment";
import ContractView from "./Contract";
import { Add, Edit, Autorenew } from "@mui/icons-material";
import MDButton from "components/MDButton";
import { BankDetails } from "./BankDetails";
import FormField from "layouts/pages/account/components/FormField";
import colors from "assets/theme/base/colors";
import { useTheme } from "@mui/material/styles";
import rgba from "assets/theme/functions/rgba";
import { useMaterialUIController } from "context";

export function Contracts() {
  const theme = useTheme();
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const palette = theme.palette;
  const [salaryDetailDialog, setSalaryDetailDialog] = useState(false);
  const [createContractDialog, setCreateContractDialog] = useState(false);
  const [createBankDialog, setCreateBankDialog] = useState(false);
  const [renewContractDialog, setRenewContractDialog] = useState(false);
  const [salaryDetails, setSalaryDetails] = useState([]);
  const [contractDetailsPayload, setContractDetailsPayload] = useState({});
  const [contractStatus, setContractStatus] = useState({name:"Active", value:true});
  const [renewFormData, setRenewFormData] = useState({
    ctc: "",
    start_date: "",
    end_date: "",
    pf_applicable: false,
    esic_applicable: false,
    gratuity_applicable: false,
    ptax_monthly: "",
  });
  const dialogPaperBase = {
    backgroundColor: darkMode ? palette.background.card : colors.white.main,
    boxShadow: darkMode ? "0 24px 48px rgba(2, 6, 23, 0.42)" : "none",
    maxWidth: "none",
    borderRadius: "20px",
    alignContent: "center",
    justifyContent: "center",
    alignItems: "center",
    border: `1px solid ${darkMode ? rgba(palette.white.main, 0.08) : rgba(colors.secondary.main, 0.14)}`,
  };


  useEffect(() => {
    if (createContractDialog == false || renewContractDialog == false) {
      getEmployeeContract(`?is_active=${contractStatus.value}`);
    }
  }, [createContractDialog, renewContractDialog, contractStatus]);
  
  async function getEmployeeContract(query) {
    var res = await ApiCalls.getEmployeeContract(query);
    if (res.success && res.code == 200) {
      contractDetails.rows = res.data.map((e) => ({
        ...e,
        contractStatus: isContractExpire(e?.end_date)
          ? "red"
          : isContractUpcoming(e?.start_date)
          ? "yellow"
          : "",
      }));

      setContractDetails({ ...contractDetails });
    }
  }
  const isContractExpire = (date) => {
    var currentDate = new Date();
    var end_date = new Date(date);
    return end_date <= currentDate;
  };
  const isContractUpcoming = (date) => {
    var currentDate = new Date();
    var start_date = new Date(date);
    return start_date > currentDate;
  };
  const [contractDetails, setContractDetails] = useState({
    columns: [
      {
        Header: "NAME",
        accessor: "name",
        bgColor: "red",
        Cell: ({ row }) => (
          <div style={{ display: "flex", alignItems: "center" }}>
            <span
            // style={{
            //   color: isContractExpire(row.original?.end_date)
            //     ? "red"
            //     : isContractUpcoming(row.original?.start_date)
            //     ? "yellow"
            //     : "",
            // }}
            >
              {row.original.bank.name_in_account}
            </span>
          </div>
        ),
      },
      {
        Header: "Start Date",
        accessor: "start_date",
      },
      {
        Header: "End Date",
        accessor: "end_date",
      },
      {
        Header: "Contract Type",
        accessor: "contract_type",
      },
      {
        Header: "CTC",
        accessor: "ctc",
      },

      {
        Header: "Action",
        accessor: "inout",
        Cell: ({ row }) => (
          <div style={{ display: "flex", alignItems: "center" }}>
            <Tooltip title="Info">
              <IconButton
                aria-label="info"
                size="small"
                onClick={() => {
                  handleView(row.original.salary_details);
                }}
              >
                <InfoIcon></InfoIcon>
              </IconButton>
            </Tooltip>
            <Tooltip title="Edit">
              <IconButton
                aria-label="edit"
                size="small"
                onClick={() => {
                  setContractDetailsPayload({ type: "edit", ...row.original });
                  setCreateContractDialog(true);
                }}
              >
                <Edit></Edit>
              </IconButton>
            </Tooltip>
            <Tooltip title="Renew">
              <IconButton
                aria-label="renew"
                size="small"
                onClick={() => {
                  setContractDetailsPayload({ ...row.original });
                  setRenewFormData({
                    ctc: "",
                    pf_applicable: false,
                    esic_applicable: false,
                    gratuity_applicable: false,
                    ptax_monthly: false,
                    start_date: row.original.start_date,
                    end_date: row.original.end_date,
                  });
                  setRenewContractDialog(true);
                }}
              >
                <Autorenew></Autorenew>
              </IconButton>
            </Tooltip>
          </div>
        ),
      },
    ],
    rows: [],
  });
  const handleView = (data) => {
    setSalaryDetails(
      data?.map((e) => ({
        amount: e?.amount,
        salary_head: e?.salary_head?.name,
        head_type: e?.salary_head?.head_type,
      }))
    );
    setSalaryDetailDialog(true);
  };

  const employeeContractRenew = async () => {
    var res = await ApiCalls.renewEmployeeContract(contractDetailsPayload.id, renewFormData, false);
    if (res.success && res.code == 200) {
      setRenewContractDialog(false);
      getEmployeeContract(`?is_active=${contractStatus.value}`);
    }
  }
  return (
    // <DashboardLayout>
    <>
      <Card>
        <MDBox
          pt={3}
          pl={3}
          pb={4}
          pr={3}
          display="flex"
          flexDirection={{ xs: "column", md: "row" }}
          justifyContent="space-between"
          gap={2}
        >
          <MDTypography variant="h4">Contracts</MDTypography>
          <MDBox display="flex"
            flexDirection={{ xs: "row", sm: "row" }}
            gap={1}
   >
            <MDButton
              color="info"
              onClick={() => {
                setCreateContractDialog(true);
                setContractDetailsPayload({ type: "create" });
              }}
              sx={{ width: {xs:"130px"}}}
            >
              Add Contract
            </MDButton>
            <div style={{ paddingLeft: "2px" }}></div>
            <MDButton
             sx={{ width: {xs:"130px"}}}
              color="info"
              onClick={() => {
                setCreateBankDialog(true);
              }}
            >
              Add Bank
            </MDButton>
          </MDBox>
        </MDBox>
        <MDBox>

           <Grid container spacing={2} pr={2} justifyContent="end">
            <Grid item width={160}>
            <Autocomplete
              width={200}
              value={contractStatus}
              options={[
                { name: "Active", value: true },
                { name: "In Active", value: false },
              ]}
              getOptionLabel={(v) => v.name}
              onChange={(event, values) => {
                setContractStatus(values??{})
              }}
              renderInput={(params) => (
                <TextField {...params} label="Status" variant="standard" />
              )}
            ></Autocomplete>
            </Grid>
           </Grid>

          <DataTable
            table={contractDetails}
            entriesPerPage={{
              defaultValue: 100,
              entries: [5, 10, 15, 20, 25, 30],
            }}
            showTotalEntries={true}
            isSorted={false}
          ></DataTable>
        </MDBox>
      </Card>
      <Dialog
        PaperProps={{
          sx: { ...dialogPaperBase, width: "auto" },
        }}
        open={salaryDetailDialog}
        onClose={() => setSalaryDetailDialog(false)}
      >
        <DialogTitle
          sx={{
            width: "100%",
            p: "20px",
            background: `linear-gradient(135deg, ${colors.info.main} 0%, ${colors.info.focus} 100%)`,
            color: "white",
          }}
        >
          <Typography sx={{ color: "white", fontWeight: "Medium" }}>
            Salary Details
          </Typography>
        </DialogTitle>
        <DialogContent
          sx={{
            p: "4px",
            backgroundColor: darkMode ? palette.background.muted : colors.white.main,
          }}
        >
          <MDBox align="center" p={2}>
            <SalesTable title="" rows={salaryDetails} />
          </MDBox>
        </DialogContent>
      </Dialog>
      <Dialog
        PaperProps={{
          sx: { ...dialogPaperBase, width: "50%" },
        }}
        open={createContractDialog}
        onClose={() => setCreateContractDialog(false)}
      >
        <DialogTitle
          sx={{
            width: "100%",
            p: "20px",
            background: `linear-gradient(135deg, ${colors.info.main} 0%, ${colors.info.focus} 100%)`,
            color: "white",
          }}
        >
          <Typography sx={{ color: "white", fontWeight: "Medium" }}>
            Add Contract
          </Typography>
        </DialogTitle>
        <DialogContent
          sx={{
            p: "4px",
            width: "100%",
            backgroundColor: darkMode ? palette.background.muted : colors.white.main,
          }}
        >
          <MDBox align="center" p={2}>
            <ContractView
              contractDetailsPayload={contractDetailsPayload}
              setContractDetailsPayload={setContractDetailsPayload}
              setCreateContractDialog={setCreateContractDialog}
            />
          </MDBox>
        </DialogContent>
      </Dialog>
      <Dialog
        PaperProps={{
          sx: { ...dialogPaperBase, width: "auto" },
        }}
        open={createBankDialog}
        onClose={() => setCreateBankDialog(false)}
      >
        <DialogTitle
          sx={{
            width: "100%",
            p: "20px",
            background: `linear-gradient(135deg, ${colors.info.main} 0%, ${colors.info.focus} 100%)`,
            color: "white",
          }}
        >
          <Typography sx={{ color: "white", fontWeight: "Medium" }}>
            Add Bank
          </Typography>
        </DialogTitle>
        <DialogContent
          sx={{
            p: "4px",
            backgroundColor: darkMode ? palette.background.muted : colors.white.main,
          }}
        >
          <MDBox align="center" p={2}>
            <BankDetails
              setCreateBankDialog={setCreateBankDialog}
            ></BankDetails>
          </MDBox>
        </DialogContent>
      </Dialog>
      <Dialog
        PaperProps={{
          sx: { ...dialogPaperBase, width: "50%" },
        }}
        open={renewContractDialog}
        onClose={() => setRenewContractDialog(false)}
      >
        <DialogTitle
          sx={{
            width: "100%",
            p: "20px",
            background: `linear-gradient(135deg, ${colors.info.main} 0%, ${colors.info.focus} 100%)`,
            color: "white",
          }}
        >
          <Typography sx={{ color: "white", fontWeight: "Medium" }}>
            Renew Contract
          </Typography>
        </DialogTitle>
        <DialogContent
          sx={{
            p: "4px",
            width: "100%",
            backgroundColor: darkMode ? palette.background.muted : colors.white.main,
          }}
        >
          <MDBox align="center" p={2}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormField
                  label="Annual CTC"
                  value={renewFormData.ctc}
                  onChange={(e) => {
                    setRenewFormData((prev) => ({
                      ...prev,
                      ctc: e.target.value,
                    }));
                  }}
                  inputProps={{ type: "number", step: "0.01" }}
                  placeholder="Enter Annual CTC"
                />
                <div style={{ height: "20px" }}></div>
                <FormField
                  label="Start Date"
                  value={renewFormData.start_date}
                  onChange={(e) => {
                    setRenewFormData((prev) => ({
                      ...prev,
                      start_date: e.target.value,
                    }));
                  }}
                  inputProps={{ type: "date" }}
                  placeholder="Enter Start Date"
                />
                <div style={{ height: "20px" }}></div>
                <FormField
                  label="End Date"
                  value={renewFormData.end_date}
                  onChange={(e) => {
                    setRenewFormData((prev) => ({
                      ...prev,
                      end_date: e.target.value,
                    }));
                  }}
                  inputProps={{ type: "date" }}
                  placeholder="Enter End Date"
                />
                <div style={{ height: "20px" }}></div>
                 <FormField
                  label="Monthly P-Tax Date"
                  value={renewFormData.ptax_monthly}
                  onChange={(e) => {
                    setRenewFormData((prev) => ({
                      ...prev,
                      ptax_monthly: e.target.value,
                    }));
                  }}
                  inputProps={{ type: "number", step: "0.01" }}
                  placeholder="Enter P-Tax Amount"
                />
              </Grid>
              {/* <FormControlLabel
                    control={
                      <Checkbox
                        checked={renewFormData.gratuity_applicable}
                        onChange={(e) => {
                          setRenewFormData((prev) => ({
                            ...prev,
                            gratuity_applicable: e.target.checked,
                          }));
                        }}
                      />
                    }
                    label="Monthly P-Tax Applicable"
                  /> */}
                  
              <Grid item xs={12}>
                <MDBox display="flex" gap={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={renewFormData.pf_applicable}
                        onChange={(e) => {
                          setRenewFormData((prev) => ({
                            ...prev,
                            pf_applicable: e.target.checked,
                          }));
                        }}
                      />
                    }
                    label="PF Applicable"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={renewFormData.esic_applicable}
                        onChange={(e) => {
                          setRenewFormData((prev) => ({
                            ...prev,
                            esic_applicable: e.target.checked,
                          }));
                        }}
                      />
                    }
                    label="ESIC Applicable"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={renewFormData.gratuity_applicable}
                        onChange={(e) => {
                          setRenewFormData((prev) => ({
                            ...prev,
                            gratuity_applicable: e.target.checked,
                          }));
                        }}
                      />
                    }
                    label="Gratuity Applicable"
                  />
                </MDBox>
              </Grid>
              <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
                <MDButton
                  variant="outlined"
                  color="secondary"
                  onClick={() => setRenewContractDialog(false)}
                >
                  Cancel
                </MDButton>
                <MDButton
                  variant="gradient"
                  color="info"
                  onClick={() => {
                    employeeContractRenew();
                    setRenewContractDialog(false);
                  }}
                >
                  Renew Contract
                </MDButton>
              </Grid>
            </Grid>
          </MDBox>
        </DialogContent>
      </Dialog>
      </>
    // </DashboardLayout>
  );
}
